import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "@/context/ContentContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import Parts from "@/pages/Parts";
import About from "@/pages/About";
import QualitySupply from "@/pages/QualitySupply";
import RequestQuote from "@/pages/RequestQuote";
import FAQ from "@/pages/FAQ";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/parts" element={<Parts />} />
            <Route path="/jcb-spare-parts" element={<Navigate to="/parts" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/quality-supply" element={<QualitySupply />} />
            <Route path="/request-a-quote" element={<RequestQuote />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
